import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Navbar } from "@/components/layout/Navbar";
import { Card } from "@/components/ui/card";
import { RegisterForm } from "@/components/auth/RegisterForm";

const Register = () => {
  const navigate = useNavigate();

  const { data: businessTypes, isLoading: isLoadingBusinessTypes } = useQuery({
    queryKey: ["businessTypes"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("business_types")
        .select("*");
      
      if (error) {
        toast.error("Erreur lors du chargement des types d'entreprises");
        throw error;
      }
      
      return data;
    },
  });

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('user_type, login_type')
          .eq('id', session.user.id)
          .single();

        // Only redirect if the user is an admin or already has a profile
        if (profile?.login_type === 'admin' && profile?.user_type === 'admin') {
          navigate('/admin');
        }
      }
    };
    
    checkUser();
  }, [navigate]);

  if (isLoadingBusinessTypes) {
    return <div>Chargement...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Créez votre compte propriétaire
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Gérez votre entreprise à distance en toute sécurité
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Card className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <RegisterForm 
              businessTypes={businessTypes || []} 
              isLoadingBusinessTypes={isLoadingBusinessTypes}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Register;